/* import __COLOCATED_TEMPLATE__ from './involvement-cta-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();